import React, {useEffect} from "react";
import "./index.scss";
import {strings} from "../../../../strings/strings";
import {UsefullInfo} from "../../../../components/UsefullInfo";
import {MtplQuotation} from "../../../../model/quotation";
import {Feedback} from "../../../../components/Feedback";
import {ProductType} from "../../../../api/model/common";
import {SendContractToEmailForm} from "../../SendContractToEmailForm";

interface GreenCardSuccessfulQuotationVieProps {
    quotation: MtplQuotation
}

export const GreenCardSuccessfulQuotationView = ({quotation}: GreenCardSuccessfulQuotationVieProps) => {

    useEffect(() => {
        let event = 'green_card_thank_you_page';
        console.log('Google Analytics Event = ' + event);
        // @ts-ignore
        window.dataLayer.push({'event': event});
    }, []);

    return (
        <div className="successful-quotation__content__left__info green-card">
            <h1>{strings.greenFinalStep.title}</h1>
            <div className="paragraph">{strings.successfullQuotationGreenCard}</div>
            <div className="paragraph">
                {strings.successfulQuotation1a}
            </div>
            <div className="paragraph">
                {strings.successfulQuotation2a}
                <span className={"accent"}> {quotation?.mtplContract.primaryInsured.email} </span>
                {strings.successfulQuotation2b}
            </div>
            <SendContractToEmailForm quotationId={quotation.id} type={ProductType.GREEN_CARD} />
            <UsefullInfo title={strings.greenFinalStep.usefullInfo.title}
                         items={[{
                             label: strings.greenFinalStep.usefullInfo.memoLabel,
                             mimeType: "pdf",
                             url: `${process.env.PUBLIC_URL}/resources/product_conditions_green_card_01_08_22.pdf`
                         }, {
                             label: strings.greenFinalStep.usefullInfo.limitsLabel,
                             mimeType: "pdf",
                             url: `${process.env.PUBLIC_URL}/resources/limits_green_card.pdf`
                         }]}/>
            <Feedback />
        </div>
    )
}